import posthog from 'posthog-js';

/**
 * Clears PostHog user data on logout
 * Should be called when user logs out to prevent data leakage on shared computers
 */
export const clearPostHogUserData = () => {
  posthog.reset(true);
};

/**
 * Identifies user in PostHog with email
 */
export const identifyUser = (email: string) => {
  posthog.identify(email, {
    email
  });
};
